module.exports = __webpack_public_path__ + "static/media/cart.639c8773.png";